module.exports = __webpack_public_path__ + "img/logo-avatar-white.1e31a345.png";